import { NativeWindow } from '@/api/ipc-api'
import { DebugHelper } from '@/helper/debugHelper'

// **Webと一致させる**
const DB_NAME = "labelyasan";
const DB_VERSION = 201903210751;

declare var window: NativeWindow

const deleteDatabase = () => {
    return new Promise(resolve => {
        const req = indexedDB.deleteDatabase(DB_NAME);
        req.onsuccess = () => {
            resolve();
        };
    });
}

const openDatabase = (): Promise<IDBDatabase> => {
    return new Promise((resolve, reject) => {
        const rq = indexedDB.open(DB_NAME, DB_VERSION);
        rq.onupgradeneeded = e => {
            const db = (e.target as unknown as { result: IDBDatabase }).result;
            // エラーが出たらどうしようもないのでtry-catchしない
            const c = db.createObjectStore("product-categories", {
                keyPath: "seq",
                autoIncrement: true
            });
            c.createIndex("id", "id", { unique: true });
            const fonts = db.createObjectStore("fonts", {
                keyPath: "id",
                autoIncrement: true
            });
            fonts.createIndex("family", "family");
        };
        rq.onsuccess = e => {
            const db = (e.target as unknown as { result: IDBDatabase }).result;
            resolve(db);
        };
        rq.onerror = reject;
    });
}

const reloadFonts = async () => {
    if (!window.api) return

    // webから状態を取れるようにする
    localStorage.setItem("local-font", "on");
    localStorage.setItem("local-font-ready", "");

    try {
        // indexedDB経由でローカルフォント情報を渡す
        const db = await openDatabase()
        const fonts = await window.api.getAvailableFonts();
        if (fonts.length === 0) {
            DebugHelper.trace("no font");
        }

        const tx = db.transaction("fonts", "readwrite");
        tx.onerror = () => {
            DebugHelper.trace("font: open transaction error");
            throw new Error("font: open transaction error");
        };

        const st = tx.objectStore("fonts");
        await Promise.all(
            fonts.map(font => {
                prepareFont(st, font)
                    .catch(e => DebugHelper.trace("font: prepare font error", e.message));
            })
        );
        DebugHelper.trace(`font: loaded. (${fonts.length} fonts)`);

        makeLocalFontReady();
    } catch(e) {
        DebugHelper.trace("font: open indexeddb error");
        makeLocalFontReady();
        throw e;
    }
}

const fontFilename = (fontPath) => {
    if (!window.api) return

    // MacだとNFD正規化されていて文字化けするのでNFC正規化
    const basename = window.api.basename(fontPath.normalize("NFC"));
    const dotIndex = basename.indexOf(".");
    if (dotIndex < 0) {
        return basename;
    } else {
        // 拡張子抜きで取り出す
        return basename.slice(0, dotIndex);
    }
}

const makeLocalFontReady = () => localStorage.setItem("local-font-ready", "yes");
const prepareFont = (st, font) => new Promise((resolve, reject) => {
    const putReq = st.put({
        fontFilename: fontFilename(font.path),
        name: font.postscriptName,
        family: font.family,
        localizedName: font.localizedName,
        enName: font.enName,
        style: font.style,
        weight: font.weight,
        italic: font.italic
    });
    putReq.onsuccess = () => {
        resolve("");
    };
    putReq.onerror = () => {
        reject(font.path);
    };
});

const migrateStores = () => Promise.all([migrateProducts(), reloadFonts()]);
const migrateProducts = async () => {
    if (!window.api) return
    const db = await openDatabase()
    const categories = await window.api.getProductCategoryList();

    const tx = db.transaction("product-categories", "readwrite");
    const cs = tx.objectStore("product-categories");
    categories.forEach(category => cs.put(category));
}

export default {
    DB_NAME,
    DB_VERSION,
    init: async () => {
        // 一旦初期化して作り直す
        await deleteDatabase();
        return migrateStores();
    },
}
